import { RouterProvider } from 'react-router-dom';

import { router } from '@/configs/routes';

const Root = () => {
  return <RouterProvider router={router} />;
};

export default Root;
